import './style.css'
import * as THREE from 'three'

let scene, renderer, camera
let windowWidth, windowHeight

let	lon = 0, lat = 0, phi = 0, theta = 0, onPointerDownMouseX = 0, onPointerDownLon = 0

const distance = 50

const video = document.getElementById('video')

const vidSources = ['/360videos/waterfall.mp4', '/360videos/waterfall2.mp4', '/360videos/house.mp4', '/360videos/waterfall3.mp4', '/360videos/village.mp4']
var vidIndex = 0
const maxLen = vidSources.length - 1


const buttonContainer = document.getElementById( 'controllersContainer' )
const startButton = document.getElementById( 'startButton' )

let leftButton = document.createElement("button")
leftButton.setAttribute("class","button")
leftButton.innerHTML = "Previous Scene"

let enterButton = document.createElement("button")
enterButton.setAttribute("class","button")
enterButton.innerHTML = ("Pause/Play Video")

let rightButton = document.createElement("button")
rightButton.setAttribute("class","button")
rightButton.innerHTML = "Next Scene"

startButton.addEventListener('click', function()
{
    init()
    animate()
    startButton.remove()
    buttonContainer.appendChild(leftButton)
    buttonContainer.appendChild(enterButton)
    buttonContainer.appendChild(rightButton)
}
)


function init() {

    const container = document.getElementById( 'container' )

    camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 1100 )

    scene = new THREE.Scene()

    const geometry = new THREE.SphereGeometry( 500, 60, 40 )
    // invert the geometry on the x-axis so that all of the faces point inward
    geometry.scale( - 1, 1, 1 )


    video.setAttribute('src', vidSources[vidIndex])
  
    video.play()

    const texture = new THREE.VideoTexture( video )
    const material = new THREE.MeshBasicMaterial( { map: texture } )

    const mesh = new THREE.Mesh( geometry, material )
    scene.add( mesh );

    renderer = new THREE.WebGLRenderer()
    renderer.setPixelRatio( window.devicePixelRatio )
    renderer.setSize( window.innerWidth, window.innerHeight )
    container.appendChild( renderer.domElement )


    document.addEventListener( 'keydown', onKeyDown )
    leftButton.addEventListener( 'click', prevScene )
    rightButton.addEventListener( 'click', nextScene )
    enterButton.addEventListener( 'click', playOrPause )

    container.addEventListener( 'pointerdown', onPointerDown )

}

function onKeyDown( event ) {
    
    switch (event.keyCode) {

        case 13: //enter key
            playOrPause()
            break
        
        case 37: //left key
            prevScene()
            break
        
        case 39: //right key
            nextScene()
            break
        }
}

function playOrPause() {
    if (video.paused) {
        video.play()
    } else if (!video.paused) {
        video.pause()
    }
}

function nextScene() {
    if (vidIndex == maxLen) {
        vidIndex = 0
    } else
    {
        vidIndex += 1 
    }

    video.setAttribute('src', vidSources[vidIndex])

    video.play()
}

function prevScene() {
    if (vidIndex == 0) {
        vidIndex = maxLen
    } else
    {
        vidIndex -= 1 
    }

    video.setAttribute('src', vidSources[vidIndex])

    video.play()
}

function onPointerDown( event ) {
    onPointerDownMouseX = event.clientX
    onPointerDownLon = lon

    document.addEventListener( 'pointermove', onPointerMove )
    document.addEventListener( 'pointerup', onPointerUp )
}

function onPointerMove( event ) {
    lon = ( onPointerDownMouseX - event.clientX ) * 0.04 + onPointerDownLon
}

function onPointerUp() {
    document.removeEventListener( 'pointermove', onPointerMove )
	document.removeEventListener( 'pointerup', onPointerUp )
}

function updateSize() {

    if ( windowWidth != window.innerWidth || windowHeight != window.innerHeight ) {

        windowWidth = window.innerWidth;
        windowHeight = window.innerHeight;

        renderer.setSize( windowWidth, windowHeight );

    }

}


function animate() {

    requestAnimationFrame( animate )
    update()

}

function update() {

    updateSize()

    //lon += 0.01
    
    lat = Math.max( - 85, Math.min( 85, lat ) )
	phi = THREE.MathUtils.degToRad( 90 - lat )
	theta = THREE.MathUtils.degToRad( lon )

	camera.position.x = distance * Math.sin( phi ) * Math.cos( theta )
	camera.position.y = distance * Math.cos( phi )
	camera.position.z = distance * Math.sin( phi ) * Math.sin( theta )

	camera.lookAt( 0, 0, 0 )

	renderer.render( scene, camera )

}

const returnButton = document.getElementById( 'returnButton' )

returnButton.addEventListener('click', function()
{
    location.replace("https://panji360.github.io/demos/")
}
)